import { render, staticRenderFns } from "./CpfOrCnpjField.vue?vue&type=template&id=79ec21fa"
import script from "./CpfOrCnpjField.vue?vue&type=script&lang=js"
export * from "./CpfOrCnpjField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports